namespace e5 {
    export type CapsOs = "windows" | "unix" | "linux" | "mac" | "android" | "ios";

    export class Caps {

        public static pixelRatio: number = 1;
        public static touchSupported: boolean = false;
        public static canvasSupported: boolean = false;
        public static workerSupported: boolean = false;
        public static formDataSupported: boolean = false;
        public static passiveEventLister: boolean = false;
        // public static isMSIE: boolean = false;
        public static isIOS: boolean = false;
        public static isFirefox: boolean = false;
        public static isMobile: boolean = false;
        public static msieVersion: number = 0;
        public static isWebkit: boolean = false;
        public static isChrome: boolean = false;
        public static isSafari: boolean = false;
        public static isInternetExplorer = (navigator.userAgent.indexOf("MSIE") != -1) || !!navigator.userAgent.match(/Trident.*rv[ :]*11\./);
        public static isEdge = /edge\//i.test(navigator.userAgent);
        public static os: CapsOs;
        public static get isStandalone(): boolean {
            return window.matchMedia('(display-mode: standalone)').matches;
        }

        public static resolve(): void {

            this.passiveEventLister = (function () {
                var supportsPassiveOption = false;
                try {
                    var opts = Object.defineProperty({}, 'passive', {
                        get: function () {
                            supportsPassiveOption = true;
                        }
                    });
                    window.addEventListener('test', null, opts);
                } catch (e) { }
                return supportsPassiveOption;
            }());

            //TODO: Jöran
            //beeing compatible to the "google-closure-compiler" for
            //better "uglifying"/minifying -> 
            //The minification reduces the overall javascript size from ~1.5MB to 500kb.
            //Functions like these will prevent the GCC from compiling a correct result.
            // if (/MSIE\s([\d.]+)/.test(navigator.userAgent)) {
            //     this.isMSIE = true;
            // }

            if (this.isInternetExplorer) {
                // this.msieVersion = parseFloat(RegExp.$1);
                // var myNav = navigator.userAgent.toLowerCase();
                // this.msieVersion = (myNav.indexOf('msie') != -1) ? parseInt(myNav.split('msie')[1]) : 1;
                this.msieVersion = (document as any).documentMode;
                // console.log(this.msieVersion);
            }

            //is ios operation system
            this.isIOS = (navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false);

            this.isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
            this.isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
            this.isFirefox = /Mozilla/.test(navigator.userAgent);
            this.isWebkit = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);//((window["URL"] || window["webkitURL"]) != null);

            //canvas support
            var elem = document.createElement('canvas');
            this.canvasSupported = Boolean(elem.getContext && elem.getContext('2d'));

            //touch support
            this.touchSupported = 'ontouchstart' in document.documentElement;

            //worker support
            this.workerSupported = typeof (Worker) !== "undefined";

            //pixel ratio
            this.pixelRatio = window["devicePixelRatio"] ? window["devicePixelRatio"] : 1;

            this.formDataSupported = !((<any>window)["FormData"] === undefined);

            //is mobile envirionment
            //SOURCE MODIFIED: http://stackoverflow.com/questions/11381673/javascript-solution-to-detect-mobile-browser
            var a = navigator.appVersion;// || navigator["vendor"] || window["opera"];
            this.isMobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4));

            //Source modified: https://stackoverflow.com/questions/9514179/how-to-find-the-operating-system-version-using-javascript
            var os: CapsOs = Caps.isMobile ? "android" : "windows";

            if (this.isIOS) {
                os = "ios";
            }
            else {
                var agent = window.navigator.userAgent.toLowerCase();
                if (agent.indexOf("windows") != -1) os = "windows";
                else if (agent.indexOf("mac") != -1) os = "mac";
                else if (agent.indexOf("android") != -1) os = "android";
                else if (agent.indexOf("x11") != -1) os = "unix";
                else if (agent.indexOf("linux") != -1) os = "linux";
                this.os = os;
            }
        }
    }

    Caps.resolve();
}